/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfrastructureExposureWeightsViewModel
 */
export interface InfrastructureExposureWeightsViewModel {
    /**
     * 
     * @type {number}
     * @memberof InfrastructureExposureWeightsViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InfrastructureExposureWeightsViewModel
     */
    local?: number;
    /**
     * 
     * @type {number}
     * @memberof InfrastructureExposureWeightsViewModel
     */
    foreign?: number;
}

/**
 * Check if a given object implements the InfrastructureExposureWeightsViewModel interface.
 */
export function instanceOfInfrastructureExposureWeightsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfrastructureExposureWeightsViewModelFromJSON(json: any): InfrastructureExposureWeightsViewModel {
    return InfrastructureExposureWeightsViewModelFromJSONTyped(json, false);
}

export function InfrastructureExposureWeightsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfrastructureExposureWeightsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'local': !exists(json, 'Local') ? undefined : json['Local'],
        'foreign': !exists(json, 'Foreign') ? undefined : json['Foreign'],
    };
}

export function InfrastructureExposureWeightsViewModelToJSON(value?: InfrastructureExposureWeightsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Percentage': value.percentage,
        'Local': value.local,
        'Foreign': value.foreign,
    };
}

